const mixUpdateCustomer = {
  data () {
    return {
      configCustomer: Object.freeze({
        companyField: 'customerCompanyID',
        relatedFields: [
          {
            fieldName: 'customerContactID',
            createField: 'contactID'
          },
          {
            fieldName: 'customerCompanyDetailID',
            createField: 'companyDetailID'
          },
          {
            fieldName: 'customerForwarderID'
          }
        ]
      })
    }
  },
  computed: {
    mixRelatedCustomerFields () {
      return this.configCustomer.relatedFields
    },
    mixCustomerField () {
      return this.configCustomer.companyField
    }
  },
  methods: {
    mixChangeCustomerID (value, payload = {}) {
      let payloadData = {}

      this.form[this.mixCustomerField] = value

      this.mixRelatedCustomerFields
        .forEach(({ fieldName }) => {
          if (this.form[fieldName]) {
            this.form[fieldName] = null
            payloadData[fieldName] = null
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixCustomerField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixCustomerField, { ...payload, payloadData })
    },
    mixCreateCustomer (data, payload = {}) {
      let payloadData = {}

      this.form[this.mixCustomerField] = data.id

      this.mixRelatedCustomerFields
        .forEach(({ fieldName, createField }) => {
          if (createField && fieldName in this.form) {
            this.form[fieldName] = data[createField]
            payloadData[fieldName] = data[createField]
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixCustomerField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixCustomerField, { ...payload, payloadData })
    }
  }
}
const mixUpdateSupplier = {
  data () {
    return {
      configSupplier: Object.freeze({
        companyField: 'supplierCompanyID',
        relatedFields: [
          {
            fieldName: 'supplierContactID',
            createField: 'contactID'
          },
          {
            fieldName: 'supplierCompanyDetailID',
            createField: 'companyDetailID'
          }
        ]
      })
    }
  },
  computed: {
    mixRelatedSupplierFields () {
      return this.configSupplier.relatedFields
    },
    mixSupplierField () {
      return this.configSupplier.companyField
    }
  },
  methods: {
    mixChangeSupplierID (value, payload = {}) {
      let payloadData = {}

      this.form[this.mixSupplierField] = value

      this.mixRelatedSupplierFields
        .forEach(({ fieldName }) => {
          if (this.form[fieldName]) {
            this.form[fieldName] = null
            payloadData[fieldName] = null
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixSupplierField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixSupplierField, { ...payload, payloadData })
    },
    mixCreateSupplier (data, payload = {}) {
      let payloadData = {}

      this.form[this.mixSupplierField] = data.id

      this.mixRelatedSupplierFields
        .forEach(({ fieldName, createField }) => {
          if (createField && fieldName in this.form) {
            this.form[fieldName] = data[createField]
            payloadData[fieldName] = data[createField]
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixSupplierField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixSupplierField, { ...payload, payloadData })
    }
  }
}
const mixUpdateShipTo = {
  data () {
    return {
      configShipTo: Object.freeze({
        companyField: 'shipToCompanyID',
        relatedFields: [
          {
            fieldName: 'shipToContactID',
            createField: 'contactID'
          },
          {
            fieldName: 'shipToCompanyDetailID',
            createField: 'companyDetailID'
          }
        ]
      })
    }
  },
  computed: {
    mixRelatedShipToFields () {
      return this.configShipTo.relatedFields
    },
    mixShipToField () {
      return this.configShipTo.companyField
    }
  },
  methods: {
    mixChangeShipToID (value, payload = {}) {
      let payloadData = {}

      this.form[this.mixShipToField] = value

      this.mixRelatedShipToFields
        .forEach(({ fieldName }) => {
          if (this.form[fieldName]) {
            this.form[fieldName] = null
            payloadData[fieldName] = null
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixShipToField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixShipToField, { ...payload, payloadData })
    },
    mixCreateShipTo (data, payload = {}) {
      let payloadData = {}

      this.form[this.mixShipToField] = data.id

      this.mixRelatedShipToFields
        .forEach(({ fieldName, createField }) => {
          if (createField && fieldName in this.form) {
            this.form[fieldName] = data[createField]
            payloadData[fieldName] = data[createField]
          }
        })

      this.updateModelItem && this.updateModelItem(this.mixShipToField, { ...payload, payloadData })
      this.autoSaveField && this.autoSaveField(this.mixShipToField, { ...payload, payloadData })
    }
  }
}

export {
  mixUpdateCustomer,
  mixUpdateSupplier,
  mixUpdateShipTo
}
